<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" md="12">
            <h3 class="text-left">จำนวนผู้ใช้แพคเกจ</h3>
          </v-col>
        </v-row>
        <v-row v-if="chartData">
        <v-card-text class="pa-0">
          <C3Chart :chartData="chartData" ></C3Chart>
        </v-card-text>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-text cols="4">
      <v-data-table
        :headers="headers"
        :items="desserts"
        :items-per-page="5"
        class="elevation-1"
      ></v-data-table>
    </v-card-text>
  </v-card>
</template>
<style>
@import '../../assets/c3.min.css';
</style>

<script>
import axios from 'axios' // api
import C3Chart from '@/components/c3.vue'
export default {
  components: {
    C3Chart
  },
  data () {
    return {
      session: this.$session.getAll(),
      chartData: null,
      desserts: [],
      headers: [
        {text: 'แพคเกจ', value: 'packageName'},
        {text: 'ราคาแพคเกจ', value: 'packageName'},
        {text: 'จำนวนครั้งของแพคเกจ', value: 'amount'},
        // {text: 'แพคเกจ', value: 'packageName'},
        {text: 'ผู้ใช้', value: 'name'}
      ]
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  mounted () {
    this.chartPackage()
  },
  methods: {
    chartPackage () {
      //   this.strDate = this.momenDate_1(dateRange.startDate)
      //   this.endDate = this.momenDate_1(dateRange.endDate)
      this.chartData = null
      axios
        .get(
          this.DNS_IP + '/piePackage/get?shopId=' + this.session.data.shopId
          // +
          // '&date_start=' +
          // this.strDate +
          // '&date_end=' +
          // this.endDate
        )
        .then(async response => {
          if (response.data.status === false) {
            this.chartData = null
          } else {
            let rs = response.data
            let lvName = []
            let count = []
            let columns2 = []
            for (let value of rs) {
              lvName.push(value['packageName'])
              count.push(value['countUser'])
            }
            for (let i = 0; i < lvName.length; i++) {
              columns2[i] = [lvName[i], count[i]]
            }
            let _this = this
            this.chartData = {
              data: {
                columns: columns2,
                type: 'donut',
                onclick: function (d) {
                  _this.getDataPackage(d)
                }
              },
              donut: {
                title: 'แพคเกจ',
                label: {
                  format: function (value) {
                    return value
                  }
                }
              }
            }
          }
        })
    },
    getDataPackage (d) {
      axios
        .get(this.DNS_IP + '/PackageLog/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          //   rs.filter(item => d.id === item.packageName)
          this.desserts = rs.filter(item => d.id === item.packageName)
          console.log(this.desserts)
        })
    }
  }
}
</script>
<style scoped>
.export-btn {
  width: 6rem;
}
.card {
  height: 25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Chart/PiePackage.vue